var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconReport = function SvgIconReport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report-svgrepo-com",
    transform: "translate(-36.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    transform: "translate(36.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    d: "M28.4,24.6c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8c0,0,0,0,0,0C36.4,28.2,32.8,24.6,28.4,24.6z  M28.4,37.6c-2.8,0-5-2.3-5-5c0-0.8,0.2-1.7,0.6-2.4l3.4,3.4c0.3,0.3,0.6,0.4,1,0.4h4.8C32.6,36.2,30.6,37.6,28.4,37.6L28.4,37.6 z M29,31.1l-3-3c2.5-1.3,5.5-0.4,6.8,2.1c0.2,0.3,0.3,0.6,0.4,0.9H29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    d: "M37,6.3h-4.2C32.3,5,31,4.1,29.6,4.1h-2.3c-0.8-1.8-3-2.7-4.8-1.9c-0.8,0.4-1.5,1-1.9,1.9h-2.3 c-1.4,0-2.7,0.9-3.2,2.2H11c-2,0-3.6,1.6-3.6,3.6v32.5c0,2,1.6,3.6,3.6,3.6h26c2,0,3.6-1.6,3.6-3.6V9.9C40.6,7.9,39,6.3,37,6.3z  M17.9,7.6L17.9,7.6c0-0.3,0.2-0.5,0.5-0.5h3.4c0.8,0,1.5-0.7,1.5-1.5c0,0,0,0,0,0c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7 c0,0.8,0.7,1.5,1.5,1.5l0,0h3.4c0.3,0,0.5,0.2,0.5,0.5v2.5c0,0.3-0.2,0.5-0.5,0.5H18.4c-0.3,0-0.5-0.2-0.5-0.5L17.9,7.6z  M37,43.2H11c-0.4,0-0.7-0.3-0.7-0.7l0,0V9.9c0-0.4,0.3-0.7,0.7-0.7l0,0h4v0.9c0,1.9,1.6,3.5,3.5,3.5h11.2c1.9,0,3.5-1.6,3.5-3.5 V9.2h4c0.4,0,0.7,0.3,0.7,0.7v0v32.5l0,0C37.7,42.8,37.4,43.2,37,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    d: "M13.1,18.9H24c0.8,0,1.5-0.7,1.5-1.5c0-0.8-0.7-1.5-1.5-1.5H13.1c-0.8,0-1.5,0.7-1.5,1.5 C11.7,18.2,12.3,18.9,13.1,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    d: "M13.1,23.2h6.5c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-6.5c-0.8,0-1.5,0.7-1.5,1.5S12.3,23.2,13.1,23.2z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    d: "M21.1,26.1c0-0.8-0.7-1.5-1.5-1.5h-6.5c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5h6.5 C20.5,27.5,21.1,26.9,21.1,26.1z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_report.c73dacf3.svg";
export { ForwardRef as ReactComponent };